/* The existing chest logo of the chosen school / shop / class, shown on the 3D
 * preview of the Create Class form until the rep uploads a front drawing. Same
 * fallback chain as the product page (API `logo_assets.school`: class create-form
 * upload → admin school upload → imported Manager URL → brand default). */
export function logoAssetsUrl(apiBase, brandSlug, schoolSlug, { shopSlug, className } = {}) {
  if (!schoolSlug) return null;
  const params = new URLSearchParams();
  if (shopSlug) params.set('shop', shopSlug);
  if (className) params.set('class', className);
  const qs = params.toString();
  return `${apiBase}/api/schools/${encodeURIComponent(brandSlug)}/${encodeURIComponent(schoolSlug)}/logo-assets${qs ? `?${qs}` : ''}`;
}

/** The chest logo URL of a logo-assets response, or null. */
export function existingChestLogo(json) {
  const url = json?.logo_assets?.school;
  return typeof url === 'string' && url !== '' ? url : null;
}
